import { Component, OnInit, Input, EventEmitter, Output, ViewChild, NgZone, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subscription } from 'rxjs';
import { catchError, distinctUntilChanged, finalize, map, startWith, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { GeoValidationService } from 'src/app/core/services/geo-validation.service';
import { Company } from 'src/app/core/interfaces/company';
import { Utils } from 'src/app/core/resources/utils';
import { AuthService } from 'src/app/core/services/authentication.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { ManualCreationCargoService } from 'src/app/modules/cargo/manual-creation-cargo/manual-creation-cargo.service';
import { AutocompleteAddressComponent } from 'src/app/shared/autocomplete-address/autocomplete-address.component';
import { environment } from 'src/environments/environment';
import { FreightListService } from '../../../cargo-list/cargo-list.service';
import { FormThirdPartyConsignmentComponent } from '../form-third-party-consignment/form-third-party-consignment.component';
import { ThirdPartyConsignmentService } from './third-party-consignment.service';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { AmountsCargoEnum } from 'src/app/core/enums/amountsCargo.enum';
import { AccountService } from 'src/app/modules/account/account.service';
import { Patterns } from 'src/app/core/resources/patterns';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { CargoStateEnum } from 'src/app/core/enums/cargoState.enum';
import { ThirdPartyAddress } from 'src/app/core/interfaces/thirdParty';
import { Permission } from 'src/app/core/resources/permission';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { ModalSelectionMapComponent } from 'src/app/shared/modal-selection-map/modal-selection-map.component';
import { Global } from 'src/app/core/resources/global';
import { CompanyManager } from 'src/app/core/managers/company.manager';
import { LocationAddress } from 'src/app/core/interfaces/locationAddress';

@Component({
  selector: 'app-third-party-consignment',
  templateUrl: './third-party-consignment.component.html',
  styleUrls: ['./third-party-consignment.component.scss'],
  providers: [ThirdPartyConsignmentService]
})
export class ThirdPartyConsignmentComponent implements OnInit {

  @Output() emitToParent: EventEmitter<any> = new EventEmitter();
  @Input() title: string;
  @Input() options: any;
  @Input() inputFormControl: FormGroup;
  @Input() isInternational = false;
  @ViewChild(AutocompleteAddressComponent) autocompleteAddressComponent: AutocompleteAddressComponent;
  @ViewChild('inputAutocomplete') inputAutocomplete: any;
  inputFormControlSubscription: Subscription;
  loadingAddresses: boolean = false;
  loadingThirdParties: boolean = false;
  rootCompanies: any[] = [];
  listThirdParties: any[] = [];
  listThirdPartiesAsync: Observable<any[]>;
  listAddresses: ThirdPartyAddress[] = [];
  listAddressesAsync: Observable<any[]>;
  listCompanies: Company[] = [];
  listCompaniesAsync: Observable<Company[]>;
  permission = Permission;

  companySelect: Company;
  companySelectCtrl = new FormControl('');

  addressSelected: any;
  addressSelectedFull: any;

  thirdPartySelected: any;
  thirdPartySelectCtrl = new FormControl('');

  cityNewAddress: string;
  newThirdParty: boolean;
  addressGeoValidating = false;
  addressGeoError: { municipalityName?: string; departmentName?: string; distanceMeters?: number } | null = null;
  optionsCity: OptionsAutocomplete = {
    title: 'Ingrese la Ciudad'
  }
  cityControl: FormControl = new FormControl();
  citySub: Subscription;
  addressControl: FormControl = new FormControl();
  addressSub: Subscription;

  constructor(
    public manualCreationCargoService: ManualCreationCargoService,
    public authService: AuthService,
    private freightListService: FreightListService,
    private thirdPartyConsignmentService: ThirdPartyConsignmentService,
    private ngZone: NgZone,
    private global: Global,
    public dialog: MatDialog,
    private accountService: AccountService,
    private snackBarService: SnackBarService,
    public utils: Utils,
    private spinner: NgxSpinnerService,
    public patterns: Patterns,
    public cdRef: ChangeDetectorRef,
    private permissionRole: PermissionRole,
    private companyManager: CompanyManager,
    private geoValidation: GeoValidationService,
  ) {
  }



  ngOnInit(): void {
    this.setSubscriptions();
    this.setAddressControl(this.inputFormControl.value);
  }

  private setSubscriptions() {
    this.citySub = this.cityControl.valueChanges
      .subscribe(value => this.cityNewAddress = value && value.id ? value.id : '');
    this.addressSub = this.addressControl.valueChanges.subscribe(this.onSelectNewAddress.bind(this));
    this.inputFormControlSubscription = this.inputFormControl.valueChanges.subscribe(value => this.setAddressControl(value));
  }

  get isCargoOwner(): boolean {
    return this.title === 'Propietario del servicio';
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
    this.rootCompanies = this.accountService.listRegisterCompanies();
    if (this.isCargoOwner)
      this.getCompanies();
    else {
      if (this.manualCreationCargoService.cargoForm.value.idCompany) {
        this.companySelect = {
          companyId: this.manualCreationCargoService.cargoForm.value.idCompany
        };
        if (this.manualCreationCargoService.getCargoForm().get('ministry').value) {
          this.getThirdParties(true);
        }
      }
    }
    this.listAddressesAsync = this.inputFormControl.valueChanges.pipe(
      map(address => address ? this.filterAddress(address) : this.filteredListAddresses ? this.filteredListAddresses.slice() : [])
    );
  }

  private setAddressControl(value: any) {
    if (!value || !value.address || !value.location || !value.location.lat || !value.location.lng) {
      if (this.addressControl.value) this.addressControl.setValue(null, { emitEvent: false });
      return;
    }
    if (value.address && value.address.address)
      return;
    const controlAddress = this.utils.getNestedValue(this.addressControl.value, 'address');
    const controlLocationLat = this.utils.getNestedValue(this.addressControl.value, 'location.lat');
    const controlLocationLng = this.utils.getNestedValue(this.addressControl.value, 'location.lng');
    if (controlAddress !== value.address || controlLocationLat !== value.location.lat || controlLocationLng !== value.location.lng) {
      this.addressControl.setValue({
        address: value.address,
        location: value.location
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.inputFormControl && !changes.inputFormControl.firstChange) {
      this.thirdPartySelectCtrl.setValue('', { emitEvent: false });
      this.companySelectCtrl.setValue('', { emitEvent: false });
      if (this.addressControl.value) this.addressControl.setValue(null, { emitEvent: false });
      this.thirdPartySelected = null;
      this.addressSelected = null;
      this.addressSelectedFull = null;
      this.addressGeoError = null;
      this.addressGeoValidating = false;
      this.setGeoError(null);
      if (this.inputFormControlSubscription) this.inputFormControlSubscription.unsubscribe();
      this.inputFormControlSubscription = this.inputFormControl.valueChanges.subscribe(value => this.setAddressControl(value));
    }
    if (changes && changes.options && !changes.options.firstChange) {
      const prevMunicipality = (changes.options.previousValue && changes.options.previousValue.city && changes.options.previousValue.city.municipalityCode) || null;
      const currMunicipality = (changes.options.currentValue && changes.options.currentValue.city && changes.options.currentValue.city.municipalityCode) || null;
      if (prevMunicipality !== null && prevMunicipality !== currMunicipality) {
        if (this.addressControl.value) this.addressControl.setValue(null, { emitEvent: false });
        this.addressSelected = null;
        this.addressSelectedFull = null;
        this.addressGeoError = null;
        this.addressGeoValidating = false;
        this.setGeoError(null);
      }
    }
    if (changes && changes.title && changes.title.currentValue && this.cityNewAddress) {
      let $ownerSubscription = this.manualCreationCargoService.cargoForm.get('cargoOwner').valueChanges.subscribe(value => {
        if (
          !this.isCargoOwner &&
          this.manualCreationCargoService.getCargoForm().get('ministry') &&
          this.manualCreationCargoService.getCargoForm().get('ministry').value) {
          this.getThirdParties();
          $ownerSubscription.unsubscribe();
        }
      });
    }
  }

  private filterThirdParties(value: any): any[] {
    if (typeof value === 'string') {
      const filterValue = value.toLowerCase();

      return this.listThirdParties.filter(thirdParty => thirdParty.name.toLowerCase().includes(filterValue));
    } else if (typeof value === 'object') {
      try {
        const filterValue = value.name.toLowerCase();
        return this.listThirdParties.filter(thirdParty => thirdParty.name.toLowerCase().includes(filterValue));
      } catch (e) {
        return [];
      }
    } else {
      return [];
    }
  }

  private filterAddress(value: any): any[] {
    if (typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.filteredListAddresses.filter(address => {
        const branchOfficeName = address && address.branchOfficeName ? address.branchOfficeName : null;
        const addressValue = address && address.address && address.address.address ? address.address.address : null;
        if (branchOfficeName && branchOfficeName.toLowerCase().includes(filterValue)) return true;
        if (addressValue && addressValue.toLowerCase().includes(filterValue)) return true;
        return false;
      });
    } else if (typeof value === 'object') {
      try {
        const filterValue = value.address.toLowerCase();
        return this.filteredListAddresses.filter(address => {
          const branchOfficeName = address && address.branchOfficeName ? address.branchOfficeName : null;
          const addressValue = address && address.address && address.address.address ? address.address.address : null;
          if (branchOfficeName && branchOfficeName.toLowerCase().includes(filterValue)) return true;
          if (addressValue && addressValue.toLowerCase().includes(filterValue)) return true;
          return false;
        });
      } catch (e) {
        return [];
      }
    } else {
      return [];
    }
  }

  private filterCompanies(value: any): Company[] {
    if (typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.listCompanies.filter(company => company.name.toLowerCase().includes(filterValue));
    } else if (typeof value === 'object') {
      try {
        const filterValue = value.name.toLowerCase();
        return this.listCompanies.filter(company => company.name.toLowerCase().includes(filterValue));
      } catch (e) {
        return [];
      }
    } else {
      return [];
    }
  }

  getAddress(companyId: string, city?: string, autoSetValue?: boolean, initialValue?: string) {
    this.loadingAddresses = true;
    if (this.inputFormControl && this.inputFormControl.get('address')) this.inputFormControl.get('address').disable();
    this.thirdPartyConsignmentService.getThirdPartiesAddressByCompany(companyId, null, null, city).subscribe(
      (success: ThirdPartyAddress[]) => {
        this.loadingAddresses = false;
        if (this.inputFormControl && this.inputFormControl.get('address')) this.inputFormControl.get('address').enable();
        this.listAddresses = success;
        if (autoSetValue) {
          if (this.filteredListAddresses && this.filteredListAddresses.length) {
            const address = this.filteredListAddresses.filter((address) => {
              if (address && address.address && address.address.location && address.address.location.lat && address.address.location.lng) {
                return address.address.location.lat === this.inputFormControl.value.location.lat &&
                  address.address.location.lng === this.inputFormControl.value.location.lng;
              } else return false;
            });
            if (address.length) {
              this.onSelectAddress(({
                option: {
                  value: address[0]
                }
              }) as MatAutocompleteSelectedEvent);
            }
          }
        }
        if (initialValue && this.filteredListAddresses && this.filteredListAddresses.length) {
          const address = this.filteredListAddresses.filter((address) => {
            const branchOfficeName = address && address.branchOfficeName ? address.branchOfficeName : null;
            const addressValue = address && address.address && address.address.address ? address.address.address : null;
            if (branchOfficeName && branchOfficeName === initialValue) return true;
            if (addressValue && addressValue === initialValue) return true;
            return false;
          });
          if (address.length) {
            this.onSelectAddress(({
              option: {
                value: address[0]
              }
            }) as MatAutocompleteSelectedEvent);
          }
        }

        this.inputFormControl.patchValue(this.inputFormControl.value);
      },
      (error) => {
        this.loadingAddresses = false;
        if (this.inputFormControl && this.inputFormControl.get('address')) this.inputFormControl.get('address').enable();
        this.listAddresses = [];
      }
    );
  }

  getThirdParties(autoSetValue?: boolean) {
    this.loadingThirdParties = true;
    this.thirdPartySelectCtrl.disable();
    this.thirdPartyConsignmentService.getThirdPartiesByParent().subscribe(
      (success: any) => {
        this.loadingThirdParties = false;
        this.thirdPartySelectCtrl.enable();
        this.listThirdParties = success;
        this.listThirdPartiesAsync = this.thirdPartySelectCtrl.valueChanges.pipe(
          startWith(''),
          distinctUntilChanged(),
          map(thirdParty => thirdParty ? this.filterThirdParties(thirdParty) : this.listThirdParties ? this.listThirdParties.slice() : [])
        );
        if (autoSetValue) {
          const thirdParty = this.listThirdParties.filter((thirdParty) => {
            return thirdParty.document === this.inputFormControl.value.thirdPartyConsignment.documentNumber;
          });
          if (thirdParty.length) {
            this.thirdPartySelectCtrl.patchValue(thirdParty[0]);
            this.onSelectThirdParty(({
              option: {
                value: thirdParty[0]
              }
            }) as MatAutocompleteSelectedEvent);
          }
        }
      },
      (error) => {
        this.loadingThirdParties = false;
        this.thirdPartySelectCtrl.enable();
        this.listThirdParties = [];
      }
    );
  }

  getCompanies(emitResponse: boolean = false) {
    if (this.authService && this.authService.getCompany() && this.authService.getCompany().subCompanies) {
      this.listCompanies = this.authService.getCompany().subCompanies.map((company) => {
        return {
          name: company.description,
          companyId: company.code,
          exclusive: this.authService.getCompany().exclusive,
          ministry: this.authService.getCompany().ministry,
          utility: this.authService.getCompany().utility,
          utilityAdditionalService: this.authService.getCompany().utilityAdditionalService,
          advancePercentage: this.authService.getCompany().advancePercentage || ((this.authService.getCompany() && this.authService.getCompany().companyId && (this.authService.getCompany().companyId === environment.rootNit) ? AmountsCargoEnum.MAX_ADVANCE_PERCENTAGE_ALLOWED_TECLOGI : AmountsCargoEnum.MAX_ADVANCE_PERCENTAGE_ALLOWED_ALL_COMPANIES)),
          transportCompany: (company as any).transportCompany,
        };
      });
      this.listCompanies.unshift(this.authService.getCompany());
      this.listCompaniesAsync = this.createCompaniesObservable();
      this.setCompanyFormControl();
    } else if (this.rootCompanies.some(rootCompany => rootCompany.nit === this.authService.getUserSession().clientCompanyId)) {
      this.freightListService.getAllCompanies().subscribe(
        (success: Company[]) => {
          this.listCompanies = success.map((company: Company) => {
            let companyMap: Company = { ...company };
            companyMap.ministry = this.utils.isDefined(company.ministry) ? company.ministry : false;
            companyMap.siigoId = company.siigoId ? company.siigoId : null;
            return companyMap;
          });
          this.listCompaniesAsync = this.createCompaniesObservable();
          this.setCompanyFormControl();
        },
        (error) => {
          this.listCompanies = [];
        }
      );
    } else {
      this.listCompanies = [this.authService.getCompany()];
      this.listCompanies[0]['ministry'] = this.utils.isDefined(this.authService.getCompany().ministry) ? this.authService.getCompany().ministry : false;
      this.manualCreationCargoService.cargoForm.get('businessName').setValue(
        this.authService.getCompany().name
      );
      this.manualCreationCargoService.cargoForm.get('idCompany').setValue(
        this.authService.getCompany().companyId
      );
      this.manualCreationCargoService.cargoForm.get('exclusive').setValue(
        this.authService.getCompany().exclusive
      );
      this.manualCreationCargoService.cargoForm.get('ministry').setValue(
        this.authService.getCompany().ministry
      );
      this.listCompaniesAsync = this.createCompaniesObservable();
      this.setCompanyFormControl();
    }
  }

  private createCompaniesObservable() {
    return this.companySelectCtrl.valueChanges.pipe(
      startWith(''),
      distinctUntilChanged(),
      map(company => company ? this.filterCompanies(company) : this.listCompanies ? this.listCompanies.slice() : [])
    );
  }

  setCompanyFormControl() {
    if (this.manualCreationCargoService.cargoForm.get('idCompany').value.length) {
      const companyFilter = this.listCompanies.filter((company) => company.companyId === this.manualCreationCargoService.cargoForm.get('idCompany').value);
      const company = companyFilter[0];
      company.ministry = this.manualCreationCargoService.cargoForm.get('ministry').value;
      this.companySelectCtrl.setValue(company);
      this.onSelectCompany(({
        option: {
          value: company
        }
      }) as MatAutocompleteSelectedEvent, true);
    }
  }

  onSelectThirdParty($event: MatAutocompleteSelectedEvent, autoSetValue?: boolean) {
    if ($event.option.value) {
      if (!autoSetValue) {
        this.addressSelected = null;
        this.addressSelectedFull = null;
      }
      this.thirdPartySelected = $event.option.value;
      this.getAddress(($event.option.value as any).document, this.options.city.municipalityCode, autoSetValue);
    } else {
      this.openDialog();
      this.newThirdParty = true;
    }
  }

  async getThirdPartiesAddressByCompany(): Promise<ThirdPartyAddress | null> {
    this.spinner.show();
    try {
      let error = false;
      const result = await this.thirdPartyConsignmentService.getThirdPartiesAddressByCompany(this.thirdPartySelected.document, null, null, this.options.city.municipalityCode).toPromise();
      if (!result || !result.length) error = true;
      const address = result.find((address: ThirdPartyAddress) => {
        return (address.address.address === this.inputFormControl.value.address) || (address.branchOfficeName === this.inputFormControl.value.address);
      });
      if (!address || !address.address.id) error = true;
      if (error) {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.ADDRESS_NOT_EDITED, undefined, 'error');
        return null;
      }
      this.spinner.hide();
      return address;
    } catch (error) {
      console.error(error);
      this.spinner.hide();
      this.snackBarService.openSnackBar(ServiceMessages.ADDRESS_NOT_EDITED, undefined, 'error');
      return null;
    }
  }

  async editThirdPartyAddressDialog() {
    let addressToSend = this.addressSelectedFull;
    if (!this.addressSelectedFull) {
      const address = await this.getThirdPartiesAddressByCompany();
      if (!address) return;
      addressToSend = address;
    }
    this.thirdPartyConsignmentService.editThirdPartyAddressDialog(this.thirdPartySelected, addressToSend, { disableCityEdition: true, alertMessage: ServiceMessages.CHANGE_ADDRESS_AFFECT_SERVICES, isInternational: !!this.isInternational }, (response?: ThirdPartyAddress) => {
      if (response) this.onSelectAddress(null, response);
    });
  }

  selectionChange() {
    if (this.inputFormControl.get('address')) {
      this.inputFormControl.get('address').setValue("");
      this.thirdPartySelected = null;
    }
    this.addressGeoError = null;
    this.addressGeoValidating = false;
    this.setGeoError(null);
  }

  addressChange() {
    this.addressSelected = null;
    this.addressSelectedFull = null;
    this.addressGeoError = null;
    this.addressGeoValidating = false;
    this.setGeoError(null);
  }

  onSelectCompany($event: MatAutocompleteSelectedEvent, autoSetValue?: boolean) {
    this.thirdPartySelected = null;
    this.addressSelected = null;
    this.addressSelectedFull = null;
    this.companySelect = { ...$event.option.value };
    this.manualCreationCargoService.setUtilityOwner(this.companyManager.getUtilityByCompanyId(this.companySelect.companyId));
    this.manualCreationCargoService.setutilityAdditionalServiceOwner(
      this.companyManager.getutilityAdditionalServicesByCompanyId(this.companySelect.companyId)
    );

    if (this.utils.isDefined(this.companySelect.advancePercentage) && this.companySelect.advancePercentage >= 0) {
      this.manualCreationCargoService.setAdvancePercentageOwner(this.companySelect.advancePercentage);
    } else {
      this.manualCreationCargoService.setAdvancePercentageOwner(this.authService && this.authService.getCompany() && this.authService.getCompany().companyId && (this.authService.getCompany().companyId === environment.rootNit) ? AmountsCargoEnum.MAX_ADVANCE_PERCENTAGE_ALLOWED_TECLOGI : this.authService.getCompany() && this.authService.getCompany().advancePercentage ? this.authService.getCompany().advancePercentage : AmountsCargoEnum.MAX_ADVANCE_PERCENTAGE_ALLOWED_ALL_COMPANIES);
    }

    this.emitToParent.emit(this.companySelect);

    if (this.manualCreationCargoService.cargoForm.get('idCompany').value.length && this.manualCreationCargoService.cargoForm.get('idCompany').value !== this.companySelect.companyId) {
      const valueMinistry = this.manualCreationCargoService.cargoForm.get('ministry').value;
      this.manualCreationCargoService.resetCargoForm();
      this.manualCreationCargoService.cargoForm.get('ministry').setValue(valueMinistry);
    }

    if (this.manualCreationCargoService.cargoForm.get('ministry').value) {
      if (this.isCargoOwner) {
        this.cargoCompanyForm = this.companySelect;
        this.getAddress(this.companySelect.companyId, null, autoSetValue);
      } else {
        this.getThirdParties();
      }
    } else {
      if (this.companySelect)
        this.cargoCompanyForm = this.companySelect;
    }
  }

  set cargoCompanyForm(company: Company) {
    this.manualCreationCargoService.cargoForm.get('idCompany').setValue(
      company.companyId
    );
    this.manualCreationCargoService.cargoForm.get('businessName').setValue(
      company.name
    );
    this.manualCreationCargoService.cargoForm.get('exclusive').setValue(
      company.exclusive
    );
  }

  filterCompany(nit: string) {
    const company = this.listCompanies.filter((company: Company) => {
      return company.companyId === nit;
    });
    if (company.length) {
      return company[0];
    }
    return null;
  }

  onSelectAddress($event, value?) {
    if (($event && $event.option && $event.option.value) || value) {
      const selectedAddress = $event && $event.option && $event.option.value ? $event.option.value : value;
      this.addressSelected = selectedAddress;
      this.addressSelectedFull = this.utils.clone(this.addressSelected);
      let data = {};
      if (this.isCargoOwner) {
        data = {
          documentType: this.addressSelected.information.documentTypeId,
          documentNumber: this.addressSelected.information.document,
          branchOffice: this.addressSelected.address.id,
          name: this.addressSelected.information.name,
          location: { lat: '', lng: '' },
          address: this.addressSelected.branchOfficeName ? this.addressSelected.branchOfficeName : this.addressSelected.address.address
        };
      } else {
        data = {
          location: this.addressSelected && this.addressSelected.address && this.addressSelected.address.location ? this.addressSelected.address.location : { lat: '', lng: '' },
          address: this.addressSelected.branchOfficeName ? this.addressSelected.branchOfficeName : this.addressSelected.address.address,
          id: this.addressSelected.address.id,
          thirdPartyConsignment: {
            address: this.addressSelected.address.address,
            documentType: this.addressSelected.information.documentTypeId,
            documentNumber: this.addressSelected.information.document,
            branchOffice: this.addressSelected.address.id,
            name: this.addressSelected.information.name,
            documentTypeName: this.addressSelected.information.documentTypeName
          }
        };
      }
      this.inputFormControl.patchValue(data);
      this.validateAddressGeo(this.addressSelectedFull);
    } else {
      this.openDialogCreateThirdPartyAddress();
    }
  }

  private validateAddressGeo(address: any): void {
    if (this.isCargoOwner) return;
    const lat = address && address.address && address.address.location && address.address.location.lat;
    const lng = address && address.address && address.address.location && address.address.location.lng;
    const cityId = this.options && this.options.city && this.options.city.municipalityCode;
    if (!lat || !lng || !cityId) {
      this.addressGeoError = null;
      this.addressGeoValidating = false;
      this.setGeoError(null);
      return;
    }
    this.addressGeoValidating = true;
    this.addressGeoError = null;
    this.geoValidation.validate({ cityId, lat: +lat, lng: +lng }).pipe(
      take(1),
      catchError(() => of({ valid: true } as any)),
      finalize(() => { this.addressGeoValidating = false; })
    ).subscribe(resp => {
      if (resp.valid) {
        this.setGeoError(null);
      } else {
        this.addressGeoError = {
          municipalityName: resp.municipalityName,
          departmentName: resp.departmentName,
          distanceMeters: resp.distanceToBoundaryMeters,
        };
        this.setGeoError(this.addressGeoError);
      }
    });
  }

  private validateDirectAddressGeo(lat: number, lng: number): void {
    if (this.isCargoOwner || this.isInternational) return;
    const cityId = this.options && this.options.city && this.options.city.municipalityCode;
    if (!cityId) {
      this.addressGeoError = null;
      this.addressGeoValidating = false;
      this.setGeoError(null);
      return;
    }
    this.addressGeoValidating = true;
    this.addressGeoError = null;
    this.geoValidation.validate({ cityId, lat: +lat, lng: +lng }).pipe(
      take(1),
      catchError(() => of({ valid: true } as any)),
      finalize(() => { this.addressGeoValidating = false; })
    ).subscribe(resp => {
      if (resp.valid) {
        this.setGeoError(null);
      } else {
        this.addressGeoError = {
          municipalityName: resp.municipalityName,
          departmentName: resp.departmentName,
          distanceMeters: resp.distanceToBoundaryMeters,
        };
        this.setGeoError(this.addressGeoError);
      }
    });
  }

  private setGeoError(error: any | null): void {
    const current = this.inputFormControl.errors || {};
    if (error) {
      this.inputFormControl.setErrors({ ...current, outsideMunicipality: error });
    } else {
      const { outsideMunicipality, ...rest } = current as any;
      this.inputFormControl.setErrors(Object.keys(rest).length ? rest : null);
    }
  }

  get hasPermissionToCreateThirdParties(): boolean {
    return this.permissionRole.hasPermission(this.permission.administration.module, this.permission.administration.createThirdParty);
  }

  get hasPermissionToCreateThirdPartyAddress(): boolean {
    return this.permissionRole.hasPermission(this.permission.administration.module, this.permission.administration.createThirdPartyAddress);
  }

  openDialogCreateThirdPartyAddress(): void {
    const dialogConfig = new MatDialogConfig();
    let thirdParty;
    let municipalityCode;
    if (this.isCargoOwner) {
      municipalityCode = this.cityNewAddress;
      thirdParty = {
        documentTypeId: '3',
        documentTypeName: this.global.documenTypes.find(doc => doc.id === '3').name,
        document: this.companySelect.companyId,
        name: this.companySelect.name
      };
    } else {
      municipalityCode = this.options.city.municipalityCode;
      thirdParty = {
        documentTypeId: this.thirdPartySelected.documentType,
        documentTypeName: this.global.documenTypes.find(doc => doc.id === this.thirdPartySelected.documentType).name,
        document: this.thirdPartySelected.document,
        name: this.thirdPartySelected.name
      };
    }
    dialogConfig.data = {
      newThirdParty: true,
      title: 'Crear dirección',
      options: {
        city: { municipalityCode: municipalityCode },
        thirdParty: thirdParty,
        isInternational: !!this.isInternational,
      }
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(FormThirdPartyConsignmentComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        if (this.isCargoOwner)
          this.getAddress(this.companySelect.companyId, this.cityNewAddress, false);
        else
          this.getAddress(this.thirdPartySelected.document, this.options.city.municipalityCode, false);
      }
    });
  }

  openAddLatLng() {
    if (!this.hasPermissionToCreateThirdPartyAddress)
      return this.snackBarService.openSnackBar("No tiene permisos para asociar una ubicación a la dirección", undefined, 'error');
    const dialogConfig = new MatDialogConfig();
    // Prioridad: ciudad recién seleccionada por el usuario en este formulario,
    // luego la ciudad heredada del cargo padre. Sin municipio, la modal abre
    // sin polígono ni validación (degradación elegante).
    const municipalityCode = this.cityNewAddress || (this.options && this.options.city ? this.options.city.municipalityCode : null);
    dialogConfig.data = {
      clickMap: true,
      ...(municipalityCode ? { municipalityCode } : {})
    };
    dialogConfig.height = ModalEnum.FORMS_HEIGHT;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(ModalSelectionMapComponent, dialogConfig).afterClosed().subscribe(result => {
      if (result && result.state && result.data && result.data.location && result.data.location.lat && result.data.location.lng)
        this.setLatLngAddress(result.data.location);
    });
  }

  private setLatLngAddress(location: LocationAddress) {
    let addressToSend = this.utils.clone(this.addressSelected);
    const addressObserver = {
      next: async (response: ThirdPartyAddress & { errorRNDC?: { error?: string } }) => {
        this.spinner.hide();
        const rndcError = this.utils.getNestedValue(response, 'errorRNDC.error');
        const { found, thirdPartyAddress } = await this.findThirdPartyAddress(addressToSend.address.address, this.addressSelected.information.document, this.options.city.municipalityCode);
        const addressLat = this.utils.getNestedValue(thirdPartyAddress, 'address.location.lat');
        const addressLng = this.utils.getNestedValue(thirdPartyAddress, 'address.location.lng');
        if (rndcError) this.snackBarService.openSnackBar(rndcError, undefined, 'error');
        else if (found && addressLat && addressLng) this.snackBarService.openSnackBar(FormMessages.ADDRESS_LOCATION_SETTED);
        else this.snackBarService.openSnackBar(ServiceMessages.ADDRESS_LOCATION_NOT_SETTED, undefined, 'error');
        this.getAddress(this.addressSelected.information.document, this.options.city.municipalityCode, false, addressToSend.branchOfficeName ? addressToSend.branchOfficeName : addressToSend.address.address);
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.ADDRESS_LOCATION_NOT_SETTED, undefined, 'error');
      },
      complete: () => {
        this.spinner.hide();
      }
    };
    this.spinner.show();

    addressToSend.address['location'] = {
      lat: Number(location.lat),
      lng: Number(location.lng)
    }
    this.thirdPartyConsignmentService.setLatLngAddresses(addressToSend).subscribe(addressObserver);
  }

  async findThirdPartyAddress(address: string, companyId: string, municipalityCode: string): Promise<{ found: boolean, thirdPartyAddress: ThirdPartyAddress }> {
    let listThirdPartiesAddresses: ThirdPartyAddress[] = [];
    try {
      listThirdPartiesAddresses = await this.thirdPartyConsignmentService.getThirdPartiesAddressByCompany(companyId, null, null, municipalityCode).toPromise();
    } catch (error) {
      console.error(error);
    }
    if (!listThirdPartiesAddresses.length) return { found: false, thirdPartyAddress: null };
    const thirdPartyAddress = listThirdPartiesAddresses.find((thirdParty: ThirdPartyAddress) => {
      const hasSameCompany = thirdParty && thirdParty.information && companyId && thirdParty.information.document === companyId;
      const hasSameAddress = !address || (address && thirdParty && thirdParty.address && thirdParty.address.address === address);
      const hasSameMunicipality = !municipalityCode || (municipalityCode && thirdParty.municipalityCode === municipalityCode);
      return hasSameCompany && hasSameAddress && hasSameMunicipality;
    });
    return { found: !!thirdPartyAddress, thirdPartyAddress };
  }

  displayThirdPartyName(thirdParty?: any): string | undefined {
    return thirdParty ? thirdParty.name : undefined;
  }

  displayCompanyName(company?: Company): string | undefined {
    return company ? company.name : undefined;
  }

  displayAddressName(address?: any): string | undefined {
    if (typeof address === 'string')
      return address;
    else if (address && address.branchOfficeName)
      return address.branchOfficeName;
    else if (address && address.address && address.address.address)
      return address.address.address;
    return undefined;

  }

  clearProperty(property) {
    this.ngZone.run(() => {
      this.cityNewAddress = null;
      switch (property) {
        case 'addressSelected':
          this.emitToParent.emit({
            data: {
              focusInput: true
            },
            options: {
              clearListener: true
            }
          });
          break;
      }
    });
  }

  onSelectNewAddress($event: { address?: string, location?: { lat: number, lng: number }, selectFromMap?: boolean } | null) {
    if ($event && $event.address && this.options) {
      if (this.utils.isDefined(this.options.indexDestination)) {
        const destinationsArray = this.manualCreationCargoService.cargoForm.get('cargoFeature.uploadDownload.destination') as FormArray;
        if (destinationsArray && destinationsArray.length) {
          const addressesDestinationsArray = destinationsArray.at(this.options.indexDestination).get('addresses') as FormArray;
          if (addressesDestinationsArray && addressesDestinationsArray.length) {
            const address = addressesDestinationsArray.at(this.options.index) as FormGroup;
            if (address) address.get('time').setValue('');
          }
        }
      } else if (this.utils.isDefined(this.options.index)) {
        const addressesOriginArray = this.manualCreationCargoService.cargoForm.get('cargoFeature.uploadDownload.origin.addresses') as FormArray;
        if (addressesOriginArray && addressesOriginArray.length) {
          const address = addressesOriginArray.at(this.options.index) as FormGroup;
          if (address) address.get('time').setValue('');
        }
      }
    }

    if ($event && $event.selectFromMap)
      return this.emitToParent.emit({
        data: {
          focusInput: true
        },
        options: this.options
      });

    let value = $event;
    if (!$event || !$event.address)
      value = {
        address: this.addressSelected,
        location: {
          lat: null,
          lng: null
        },
      };
    if (value) this.inputFormControl.patchValue(value);
    if ($event) this.emitToParent.emit({ data: { ...$event, refreshMarkers: true }, options: this.options });

    if ($event && $event.location && $event.location.lat && $event.location.lng) {
      this.validateDirectAddressGeo($event.location.lat, $event.location.lng);
    } else if (!$event || !$event.address) {
      this.addressGeoError = null;
      this.addressGeoValidating = false;
      this.setGeoError(null);
    }
  }

  openDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      newThirdParty: true,
      title: this.title,
      options: {
        ...this.options,
        currentThirdPartyList: this.listThirdParties,
        isInternational: !!this.isInternational
      }
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(FormThirdPartyConsignmentComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      result && result.state && this.getThirdParties();
    });
  }

  get showAddressField(): boolean {
    return (
      this.thirdPartySelected && this.thirdPartySelected.name ||
      (this.isCargoOwner && this.companySelect && this.companySelect.name)
    ) && this.manualCreationCargoService.getCargoForm().get('ministry').value;
  }

  disableByCity(address): boolean {
    return false;
  }

  get cargoStateEnum(): typeof CargoStateEnum {
    return CargoStateEnum;
  }

  isCompanyInactive(company: Company): boolean {
    return !this.utils.companyIsActive(company);
  }
  getTooltip(company: Company): string {
    if (!this.isCompanyInactive(company)) return '';
    let message = "Empresa inactiva";
    const description = this.utils.getNestedValue(company, 'state.description');
    if (description) message += `: ${description}`;
    return message;
  }


  get hasPermissionToViewDeletedAddresses(): boolean {
    return this.permissionRole.hasPermission(this.permission.administration.module, this.permission.administration.viewDeletedThirdpartyAddresses);
  }

  get filteredListAddresses() {
    if (!this.listAddresses || !this.listAddresses.length) return [];
    if (this.hasPermissionToViewDeletedAddresses) return this.listAddresses;
    return this.listAddresses.filter(address => this.utils.thirdPartyAddressIsActive(address));
  }

  ngOnDestroy() {
    if (this.citySub) this.citySub.unsubscribe();
    if (this.addressSub) this.addressSub.unsubscribe();
    if (this.inputFormControlSubscription) this.inputFormControlSubscription.unsubscribe();
    this.cdRef.detach();
  }
}
